<template>
  <div class="status-wrapper">
    <div class="status-bar">
      <timeline-step
        v-for="step in timeline"
        :key="step.id"
        :status="step.status"
        :step="step.step"
        :title="step.title"
        :maximumStep="stepCount"
        :configuration="step"
        @titleClicked="currentstep = $event"
        @todoListClicked="emit('todoListClicked')"
      >
        <template v-slot:caption v-if="useV2 && currentstep === step.step">
          <timeline-step-description
            class="mobile"
            :step="step.step"
            :status="selectedStep.status"
            :mobile="true"
            @viewCertificationUpdates="emit('viewCertificationUpdates')"
          />
        </template>
      </timeline-step>
    </div>

    <template v-if="useV2">
      <div class="divider"></div>
      <timeline-step-description
        :step="selectedStep.step"
        :status="selectedStep.status"
        @viewCertificationUpdates="emit('viewCertificationUpdates')"
      />
    </template>
  </div>
</template>
<script setup lang="ts">
import { useStore } from "vuex";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import TimelineStepDescription from "@/components/timeline/TimelineStepDescription.vue";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";

useStore();

const emit = defineEmits<{
  (e: "todoListClicked"): void;
  (e: "viewCertificationUpdates"): void;
}>();

const { useV2, timeline, currentstep, selectedStep, stepCount } = useApplicationStatus();
</script>
